import { Component, AfterContentInit, OnInit } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DossierDTO, DivisionDTO, MasterDataDTO } from '../../api/plyca-dtos';
import { UserService } from '../../user.service';
import { UIService } from '../../ui.service';
import { RuleDTO, RuleOpeningModeTypeDTO } from '../../api/plyca-dtos-v2';
import { forkJoin } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { TaskService } from '../../tasks/task.service';
import { RuleService } from './RuleService';
import { DossierService } from '../dossier.service';
import * as lodash from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { TreeNode } from 'primeng-lts/api';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'rules',
  templateUrl: 'rules.template.html'
})
export class rulesComponent extends BaseComponent implements OnInit, AfterContentInit {
  loaded = false;

  dossierId: string;
  dossier: DossierDTO;
  rules: RuleDTO[];
  // divisiones: DivisionDTO[];
  rootDivision: DivisionDTO;
  groupedInfo: Array<TreeNode>;

  constructor(
    public plycaService: PlycaDataService,
    public taskService: TaskService,
    public ruleService: RuleService,
    public userService: UserService,
    public dossierService: DossierService,
    public uiService: UIService,
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public router: Router,
    public dialogService: DialogService,
    public configuration: Configuration
  ) {
    super();
    this.subscribe(route.params, params => {
      this.dossierId = params['id'];
    });
  }

  ngOnInit() { }

  ngAfterContentInit(): void {
    this.load();
  }

  public isLoaded() {
    return this.dossier && this.loaded;
  }

  load() {
    this.loaded = false;
    this.subscribe(forkJoin(
      this.plycaService.getDossier(this.dossierId),
      this.plycaService.getDossierRules(this.dossierId),
      //      this.plycaService.getDossierDivisions(this.dossierId)
      this.dossierService.getDivisionsTree(this.dossierId)
    ), result => {
      this.dossier = result[0];
      if (result[1] && result[1].content) {
        // this.rules = result[1].content;
        // FILTRAR REGLAS QUE NO SE PUEDAN PROCESAR EN EL CLIENTE WEB
        this.rules = result[1].content.filter(
          rule => RuleOpeningModeTypeDTO.appletOnly !== rule.openingMode
        );
      }
      if (result[2]) {
        this.rootDivision = result[2];
      }
      // if (this.rules) {
      //   this.recurseDivisions(this.rootDivision);
      // }
      this.groupInfo();
      this.loaded = true;
    });
  }

  // recurseDivisions(division: DivisionDTO) {
  //   let rulesInDivision = this.rules.filter(
  //     rule => rule.division.identifier === division.identifier
  //   );
  //   // si no hay reglas en la divisino las clono
  //   if (rulesInDivision && rulesInDivision.length === 0) {
  //     let newRule: RuleDTO = lodash.cloneDeep(this.rules[0]);
  //     let PREFIX = 'TEMP_RULE_';
  //     newRule.division = division;
  //     newRule.identifier = PREFIX + newRule.identifier;
  //     newRule.description = PREFIX + newRule.description;
  //     newRule.name = PREFIX + newRule.name;

  //     this.rules.push(newRule);
  //   }

  //   if (division.children && division.children.length > 0) {
  //     division.children.forEach(division => this.recurseDivisions(division));
  //   }
  // }

  countPendingsBySeverity(severity: string): number {
    if (this.rules) {
      return this.rules.filter(
        rule => rule.severity === severity && this.isRuleExecutable(rule)
      ).length;
    } else {
      return 0;
    }
  }

  groupInfo() {
    this.groupedInfo = [];
    let divisionNode = this.division2Node(this.rootDivision);
    if (divisionNode.children && divisionNode.children.length > 0) {
      this.groupedInfo.push(divisionNode);
    }
  }

  division2Node(division: DivisionDTO): TreeNode {
    let icon = 'fa-2x  fa-folder-o ';
    // hack para la descripcion en el tree
    division['description'] = division.name;
    let divisionNode: TreeNode = {
      data: division,
      expanded: true
      // ,children: this.children2Nodes(division)
    };
    divisionNode['children'] = this.children2Nodes(division);
    division['icono'] = icon;
    this.clasifyDivisionRulesByPriority(divisionNode);
    return divisionNode;
  }

  severity2Node(severity: any): TreeNode {
    let icon = 'fa-2x ';
    if (severity === 'mandatory') {
      icon += 'fas fa-exclamation-circle text-danger';
    } else {
      icon += 'fas fa-question-circle text-info';
    }
    let node: TreeNode = {
      data: {
        description: this.translateService.instant(
          'Rules.Severity.' + severity
        ),
        icono: icon
      },
      expanded: true,
      children: []
    };
    return node;
  }

  rule2Node(rule: RuleDTO): TreeNode {
    //    let icon = 'fa-2x fa-caret-square-o-right';
    let node: TreeNode = {
      type: 'rule',
      data: rule
    };
    rule['icono'] = 'fa-2x ' + this.ruleService.getRuleIcon(rule);
    return node;
  }

  // private getRuleIcon(rule: RuleDTO): string {
  //   let ret = 'fa-2x ';
  //   if (rule.type === undefined) {
  //     // si no tiene tipo no se puede ejecutar todavia (como los cambios de fase que no se cumplen)
  //     ret += 'far fa-stop-circle';
  //   } else if (rule.state === RuleStates.COMPLETED) {
  //     // finalizada
  //     ret += 'far fa-check-circle  text-success';
  //   } else if (
  //     rule.state === RuleStates.PROCESSING ||
  //     (rule.state === RuleStates.PENDING &&
  //       rule.type === RuleTypes.TASK &&
  //       rule.locked)
  //   ) {
  //     // en ejecucion (tiene tipo y state processing)
  //     ret += 'far fas fa-play-circle text-info';
  //     // } else if (rule.state === RuleStates.PROCESSING) { // en ejecucion (tiene tipo y state processing)
  //     //   ret = 'far fa-pause-circle';
  //   } else {
  //     ret += 'far fa-pause-circle'; // ?
  //   }
  //   return ret;
  // }

  phase2Node(phase: MasterDataDTO) {
    let icon = 'fa-2x fa-file-o ';
    let node = {
      data: phase,
      expanded: true,
      children: []
    };
    phase['icono'] = icon;
    return node;
  }

  children2Nodes(divisionNode: DivisionDTO) {
    let _children = [];
    if (divisionNode.children) {
      divisionNode.children.forEach(child => {
        let tmp = this.division2Node(child);
        _children.push(tmp);
      });
    }
    return _children;
  }

  /*
   * Agrupar las reglas por division / fase / prioridad
   */
  clasifyDivisionRulesByPriority(divisionNode: TreeNode) {
    let division = divisionNode.data;
    if (!divisionNode.children) {
      divisionNode.children = [];
    }
    let divisionRules = [];
    if (this.rules) {
      divisionRules = this.rules
        .filter(rule => rule.division.identifier === division.identifier)
        .sort((rule1, rule2) => (rule1.severity > rule2.severity ? 1 : -1));

      if (divisionRules) {
        divisionRules
          .map(rule => rule.phase.identifier)
          .filter((value, index, self) => self.indexOf(value) === index)
          .forEach(phase => {
            let phaseRules = divisionRules
              .filter(rule => rule.phase.identifier === phase)
              .sort((rule1, rule2) =>
                rule1.phase.description < rule2.phase.description ? 1 : -1
              );
            // utilizamos la phase de una regla cualquiera para que tenga la descripcion
            let phaseNode = this.phase2Node(phaseRules[0].phase);
            divisionNode.children.push(phaseNode);
            phaseRules
              .map(rule => rule.severity)
              .filter((value, index, self) => self.indexOf(value) === index)
              .forEach(severity => {
                let severityNode = this.severity2Node(severity);
                phaseNode.children.push(severityNode);
                phaseRules
                  .filter(rule => rule.severity === severity)
                  .sort((rule1, rule2) =>
                    rule1.description < rule2.description ? 1 : 0
                  )
                  .forEach(rule =>
                    severityNode.children.push(this.rule2Node(rule))
                  );
              });
          });
      }
    }
  }

  isRuleExecutable(rule: RuleDTO): boolean {
    return this.ruleService.isRuleExecutable(rule);

    // La regla es ejecutable si cumple estas condiciones:
    // 1. Es manual
    // 2. Tiene type (por ejemplo los cambios de fase que no se cumplen todavia no lo tienen)
    // 3. Es state es pending
    // let ret: boolean;
    // ret = rule.executionType === RuleExecutionTypes.MANUAL; // 1
    // ret = ret && rule.type !== undefined; // 2
    // ret = ret && rule.state === RuleStates.PENDING;
    // //    ret = ret && (rule.type !== RuleTypes.TASK || rule.type === RuleTypes.TASK && !rule.locked);
    // ret = ret && !rule.locked;
    // console.log('COMPROBANDO SI LA REGLA ', rule, 'ES EJECUTABLE: ', ret);

    // return ret;
  }

  // COMPRUEBA SI LA REGLA ES EJECUTABLE Y DE TIPO PROCEDURE
  isProcedureExecutable(rule: RuleDTO): boolean {
    return this.ruleService.isProcedureExecutable(rule);
    //    return this.isRuleExecutable() && rule.type === RuleTypes.PROCEDURE;
  }

  isProcedureAuditable(rule: RuleDTO): boolean {
    return this.ruleService.isProcedureAuditable(rule);
    // let ret: boolean;
    // ret =
    //   (rule.state === RuleStates.COMPLETED ||
    //     rule.state === RuleStates.PROCESSING) &&
    //   rule.type === RuleTypes.PROCEDURE &&
    //   rule.procedure !== undefined;
    // return ret;
  }

  executeRule(rule: RuleDTO) {
    let execResult = this.ruleService.executeRule(rule);
    // si la regla no es de tipo task devuelve un observable
    if (execResult) {
      execResult.subscribe(() => {
        this.load();
      });
    }
    // this.plycaService
    //   .get<RuleDTO>(this.configuration.RULES_SERVICE_URL, rule.identifier)
    //   .subscribe(_rule => {
    //     if (_rule.type === RuleTypes.TASK) {
    //       if (rule.task) {
    //         this.taskService.openTask(_rule.task);
    //       } else {
    //         console.error(
    //           'REGLA EJECUTABLE DE TIPO TASK SIN TAREA ASOCIADA',
    //           _rule
    //         );
    //       }
    //     } else {
    //       let url =
    //         this.configuration.RULES_SERVICE_URL + rule.identifier + '/execute';
    //       this.plycaService.put(url).subscribe(() => {
    //         // timer(2000).subscribe(() => this.emitUpdate())
    //         this.load();
    //       });
    //     }
    //   });
  }

  executeProcedure(rule: RuleDTO) {
    this.subscribe(this.ruleService.executeProcedure(rule), procedure => {
      if (procedure) {
        console.log('Regla ejecutado: ', procedure);
        this.load();
      }
    });
    // console.log('Ejecutando regla', rule);
    // let config: DynamicDialogConfig = {
    //   header: 'Ejecutar regla',
    //   width: '70%'
    // };
    // config['rule'] = rule;
    // config['dossier'] = this.dossier;
    // config['divisiones'] = this.rootDivision;
    // const ref = this.dialogService.open(procedureComponent, config);

    // ref.onClose.subscribe((procedure: ProcedureDTO) => {
    //   if (procedure) {
    //     console.log('Regla ejecutado: ', procedure);
    //     this.load();
    //   }
    // });
  }

  openAudit(rule: RuleDTO) {
    this.ruleService.openAudit(rule);
    // this.router.navigate(['/audit/' + this.dossier.identifier], {
    //   queryParams: {
    //     procedureId: getSimpleIdentifierFromString(rule.procedure.identifier)
    //   }
    // });
  }
}
